import { IChatV2Schema } from '@cian/chats-api';

// eslint-disable-next-line import/no-cycle
import { ERequestApiStatus } from './appState';
import { TMessageSchema } from './messages';
import { TOffer } from './offer';
import { TRoute } from './route';
import { TType as TChatInListType } from '../repositories/chats/entities/chat/ChatDataInListSchema';
import { IOfferSchema } from '../repositories/chats/entities/offer/OfferSchema';
import { ISyncChatSchema } from '../repositories/chats/entities/synchronization/SyncChatSchema';
import {
  TStatus as TStatusSyncChatSchema,
  TFilterBy as TFilterBySyncChatSchema,
} from '../repositories/chats/entities/synchronization/V2ScrollSynchronizationRequestSchema';

// Количество чатов на 1 страницу
const CHATS_ON_PAGE_LIMIT = 25;

export type IChat = Omit<IChatV2Schema, 'datetimeForSorting' | 'offer' | 'lastMessage'> & {
  /** Заменям стринговую дату на timestamp */
  updated: number;
  offer?: TOffer;
  lastMessage?: TMessageSchema;
};

type TChatListState = {
  status: ERequestApiStatus;
  currentPage: number;
  currentRoute: TRoute;
  chats: IChat[];
  allChatsLoaded?: boolean;
  timestamp?: number;
  timestampSpam?: number;
  timestampArchive?: number;
  timestampStarred?: number;
  movedToSpamChatIds: string[];
  removedFromSpamChatId?: string;
  movedToArchiveChatIds: string[];
  removedFromArchiveChatId?: string;
  notClearCurrentOpenedChatId?: boolean;
  isChangeListActive: boolean;
  isLoadProgress: boolean;
  isFirstLoad: boolean;
  selectedChats: string[];
};

export { CHATS_ON_PAGE_LIMIT, type TChatInListType, type TStatusSyncChatSchema, type TFilterBySyncChatSchema };
export type { TChatListState, ISyncChatSchema as TSingleChatV2Response, IOfferSchema as TSingleChatV2Offer };
